module.exports = __webpack_public_path__ + "img/dogecoin-bg.85a1ef5d.png";